import React, { useEffect, Fragment, useState } from 'react';
import i18n from 'i18next';
import Button from '@/Components/Button';
import Guest from '@/Layouts/Guest';
import { Head, Link, useForm, usePage } from '@inertiajs/inertia-react';
import { FormInput, PhoneOrEmailInput } from "@/Components/Controls";
import AbstractLoginArtwork from "@/Components/AbstractLoginArtwork";
import ProductLogo from "@/Components/ProductLogo";

export default function Login({ status }) {
    const { data, setData, post, processing, errors, reset } = useForm({
        email_or_phone: '',
        password: '',
        remember: '',
        query_params: usePage().props.queryParams
    });

    const [state, setState] = useState({
        continueLogin: false,
        preventSubmit: false
    });

    useEffect(() => {
        return () => {
            reset('password');
        };
    }, []);

    const onChange = (name, value) => {
        setData(name, value);
    };

    function checkToPreventSubmit(e) {
        if ((e.key === 'Enter' || e.keyCode === 13) && !state.continueLogin) {
            setState({...state, preventSubmit: true, continueLogin: true});
        }
    }

    const submit = (e) => {
        e.preventDefault();

        if (!state.preventSubmit) {
            post(route('login.store'));
        }

        setState({...state, preventSubmit: false});
    };

    return (
        <Guest>
            <Head>
                <title>Log in</title>
            </Head>
            <AbstractLoginArtwork/>
            <div className="login">
                {status && <div className="status">{status}</div>}
                <form onSubmit={submit}>
                    <ProductLogo />
                    <div className="row">
                        <PhoneOrEmailInput error={errors["email_or_phone"]}
                                           name="email_or_phone"
                                           isFocused={true}
                                           autoComplete="username"
                                           value={data.email_or_phone}
                                           onChange={onChange}
                                           onKeyDown={(e) => checkToPreventSubmit(e)}
                                           label={i18n.t("login.email-or-phone")}
                                           className="col-12"
                                           dataQa="login-tab-choose-username"/>
                    </div>
                    {!state.continueLogin &&
                        <Fragment>
                            <div onClick={() => setState({...state, continueLogin: true})} className="w-100 btn btn-primary">
                                {i18n.t("login.continue")}
                            </div>
                        </Fragment>
                    }
                    {state.continueLogin &&
                        <Fragment>
                            <div className="row">
                                <FormInput format="password"
                                           error={errors["password"]}
                                           name="password"
                                           isFocused={true}
                                           autoComplete="current-password"
                                           value={data.password}
                                           onChange={onChange}
                                           label={i18n.t("login.password")}
                                           className="col-12"
                                           dataQa="login-tab-password"/>
                            </div>
                            <div className="">
                                <Button className="w-100 btn btn-primary" processing={processing}>
                                    {i18n.t("login.log-in")}
                                </Button>
                            </div>
                            <div className={"forgot-password-link"}>
                                <Link
                                    href={route('password.request')}
                                    class="btn btn-link text-center"
                                >
                                    {i18n.t("login.forgot-password")}
                                </Link>
                            </div>
                        </Fragment>
                    }
                </form>
            </div>
        </Guest>
    );
}
